/* eslint-disable */

import Vue from "vue";
import App from "./App.vue";
import router from "./routes/router";
import store from "./store";

import AdminLayout from "./layouts/Admin.vue";
import ClientLayout from "./layouts/Client.vue";
import LottieWrapper from "./components/LottieWrapper.vue";
import zoomModal from "./components/ZoomModal.vue";

import { firestorePlugin } from "vuefire";
import VueWaypoint from "vue-waypoint";
import Lottie from "vue-lottie";
import Toasted from "vue-toasted";
import VueLazyload from "vue-lazyload";
import Meta from "vue-meta";

import AOS from "aos";
import "aos/dist/aos.css";
import VueRellax from "vue-rellax";
import VueYoutube from "vue-youtube";
import VModal from "vue-js-modal";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import { dbRefs } from "./services/firebase/init";

Vue.use(VueRellax);
Vue.use(VueLazyload);
Vue.use(VueWaypoint);
Vue.use(firestorePlugin);
Vue.use(Meta);
Vue.use(VueYoutube);
Vue.use(VModal);
Vue.use(VueAwesomeSwiper);

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHome,
  faMask,
  faAddressBook,
  faTrash,
  faTimesCircle,
  faTheaterMasks,
  faSignOutAlt,
  faUserCog,
  faUserPlus,
  faEye,
  faPlusCircle,
  faAirFreshener,
  faPhoneSquare,
  faTicketAlt,
  faBookOpen,
  faFolder,
  faFile,
  faLink,
  faCircle,
  faSun,
  faBook,
  faArrowCircleDown,
  faArrowDown,
  faCheck,
  faMinusCircle,
  faNewspaper,
  faStickyNote,
  faEllipsisV,
} from "@fortawesome/free-solid-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from "@fortawesome/vue-fontawesome";
import {
  faEdit,
  faClock,
  faCalendarAlt,
  faImages,
  faCircle as farCircle,
} from "@fortawesome/free-regular-svg-icons";

library.add(
  faEdit,
  faHome,
  faMask,
  faAddressBook,
  faClock,
  faTrash,
  faTimesCircle,
  faTheaterMasks,
  faCalendarAlt,
  faImages,
  faSignOutAlt,
  faUserCog,
  faUserPlus,
  faEye,
  faPlusCircle,
  faAirFreshener,
  faPhoneSquare,
  faTicketAlt,
  faBookOpen,
  faFolder,
  faFile,
  faLink,
  faCircle,
  faSun,
  faBook,
  faArrowCircleDown,
  faArrowDown,
  faCheck,
  farCircle,
  faMinusCircle,
  faNewspaper,
  faStickyNote,
  faEllipsisV
);

AOS.init();
Vue.component("icon-vue", FontAwesomeIcon);
Vue.component("icon-layers", FontAwesomeLayers);

import { firebaseAuth } from "./services/firebase/init";
import GeneralMixin from "./mixins/general";
import ScrollMixin from "./mixins/scroll";
import ContentMixin from "./mixins/content";
import BootstrapVue from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/sass/admin/index.scss";
import "./assets/sass/client/index.scss";

import "hover.css/css/hover-min.css";
import "animate.css/animate.min.css";

import { cleanDate } from "./filters/dates";

const _ = require("lodash");

Vue.config.productionTip = false;
Vue.mixin(GeneralMixin);
Vue.mixin(ScrollMixin);
Vue.mixin(ContentMixin);
Vue.component("default-layout", ClientLayout);
Vue.component("admin-layout", AdminLayout);

Vue.component("lottie", Lottie);
Vue.component("lottie-wrapper", LottieWrapper);
Vue.component("zoom-modal", zoomModal);

Vue.use(BootstrapVue);
Vue.use(Toasted, {
  position: "bottom-center",
  duration: 5000,
  iconPack: "fontawesome",
  theme: "toasted-primary",
  icon: {
    name: "exclamation-circle",
    after: false,
  },
});

Vue.filter("literalDate", cleanDate);

let app = "";
firebaseAuth.onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: (h) => h(App),
      mounted() {
        this.$store.dispatch("fetchCollection", {
          ref: dbRefs.sponsorRef,
          collectionName: "sponsors",
        });
        this.$store.dispatch("fetchCollection", {
          ref: dbRefs.filesRef2,
          collectionName: "files",
        });
        this.$store.dispatch("fetchCollection", {
          ref: dbRefs.scheduleRef,
          collectionName: "schedule",
        });
      },
    }).$mount("#app");
  }
  if (user) {
    const { uid, email, phoneNumber, photoURL, emailVerified } = user;
    if (!store.getters.profileLoaded) {
      store.commit("updateProfile", {
        uid,
        email,
        phoneNumber,
        photoURL,
        emailVerified,
      });
    }
  } else {
    if (store.getters.profileLoaded) {
      store.commit("updateProfile", {});
    }
  }
});
